module.exports = __webpack_public_path__ + "img/watergeuzen.dfddf5e5.jpeg";